// src/components/home/GiftVoucher.js
import React from 'react';
import { Card, Image, Typography, Button } from 'antd';
import { GiftOutlined } from '@ant-design/icons';
import './GiftVoucher.css';

const { Title, Paragraph } = Typography;

const GiftVoucher = () => {
  return (
    <div className="gift-voucher-wrapper">
      <Card className="gift-voucher-card" bordered={false}>
        <div className="gift-voucher-content">
          <div className="gift-voucher-image">
            <Image
              src={`${process.env.PUBLIC_URL}/img/CadeauBon.png`}
              alt="Cadeaubon Trimsalon 't Trimmerke"
              preview={false}
              width="100%"
              style={{ maxWidth: '300px', borderRadius: '12px' }}
            />
          </div>
          <div className="gift-voucher-text">
            <Title level={3} className="gift-voucher-title">
              <GiftOutlined /> Cadeaubon
            </Title>
            <Paragraph className="gift-voucher-description">
              De cadeaubonnen zijn vanaf nu beschikbaar! Het perfecte cadeau voor een verjaardag, 
              feestdag of gewoon zomaar. Een beetje extra verzorging en aandacht voor hun trouwe viervoeter 🤎
            </Paragraph>
            <Paragraph strong style={{ fontSize: '1.1rem', marginBottom: 24 }}>
              Spring gerust binnen om er eentje te komen halen!
            </Paragraph>
            
          </div>
        </div>
      </Card>
    </div>
  );
};

export default GiftVoucher;